import domReady from "@wordpress/dom-ready";
import { animateSlides, swiperCreateNew } from "./swiper-settings";

let mySwipers = [];

const breakpoint = window.matchMedia("(min-width: 768px)");

const breakpointChecker = () => {
	if (breakpoint.matches === true) {
		destroyAllSwipers();
		initSwipers();
	} else if (breakpoint.matches === false) {
		destroyAllSwipers();
		animateAllItems();
	}
};

const initSwipers = () => {
	const allCarouselSections = document.querySelectorAll(
		".wp-block-theme-blocks-slider-items",
	);

	for (const section of allCarouselSections) {
		const itemsContent = section.querySelector(".slider-items__content");
		if (!itemsContent?.classList.contains("is-slider")) continue;
		const thisSwiper = swiperCreateNew(section.id);
		mySwipers.push(thisSwiper);
	}
};

const animateAllItems = () => {
	const allCarouselSections = document.querySelectorAll(
		".wp-block-theme-blocks-slider-items",
	);
	allCarouselSections?.forEach((section) => {
		const items = section.querySelectorAll(".slider-items__item");
		animateSlides(items, section);
	});
};

const destroyAllSwipers = () => {
	mySwipers.forEach((swiper) => {
		if (swiper !== undefined) swiper.destroy(true, true);
	});
	mySwipers = [];
};

domReady(() => {
	breakpoint.addEventListener("change", breakpointChecker);
	breakpointChecker();
	animateAllItems();
});
